<template>
    <div>
        <h5>{{ app ? app.app_name : ''}}</h5>
        <el-container>
            <el-aside width="180px">
                <SubMenu activeIndex="2" />
            </el-aside>
            <el-main>
                <el-form :model="app">
                    <el-form-item label="检查应用名称">
                        <el-input v-model="app.app_name"></el-input>
                    </el-form-item>
                    <el-form-item label="检查频率">
                        <el-radio-group v-model="app.frequency">
                            <el-radio label="只能检查一次"></el-radio>
                            <el-radio label="每天检查一次"></el-radio>
                            <el-radio label="每天检查多次"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="公开查询">
                        <el-switch v-model="app.is_public_query">
                        </el-switch>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" class="btn-create" @click="handleEditApp">保存更改</el-button>
                        <el-button type="danger" class="btn-create" @click="handleDelete">删除应用</el-button>
                    </el-form-item>
                </el-form>
            </el-main>
        </el-container>
    </div>
</template>
<script>
import axios from 'axios'
import config from '../config.js'
import { Tag } from 'iview';
import SubMenu from './SubMenu.vue'
export default {
    components: {
        Tag,
        SubMenu
    },
    data() {
        return {
            app_id: '',
            app: null

        }

    },
    created() {
        this.app_id = this.$route.params.app_id
        let app = JSON.parse(localStorage.getItem(this.app_id))
        if (!this.app) { this.getApp() }
        this.setApp(app)
        //console.log(this.app)

    },
    methods: {

        getApp() {
            let url = config.base_url + '/yun_table/yun_jiancha/apps/' + this.app_id
            axios.get(url, {
                headers: {
                    "Authorization": localStorage.getItem('token')
                }
            }).then((response) => {
                //console.log(response)
                let res = response.data
                localStorage.setItem(response.data.app_id, JSON.stringify(response.data))
                this.setApp(res)
            }).catch((err) => {
                //console.log(err);
            })
        },
        setApp(app) {
            this.app = app
            if (app.is_public_query == '1') {
                this.app.is_public_query = false
            }
            if (app.is_public_query == '2') {
                this.app.is_public_query = true
            }
            if (app.frequency == '1') {
                this.app.frequency = '只能检查一次'
            }
            if (app.frequency == '2') {
                this.app.frequency = '每天检查一次'
            }
            if (app.frequency == '3') {
                this.app.frequency = '每天检查多次'
            }
        },
        handleEditApp() {
            let app = this.app;
            let _this = this;
            if (!app.app_name) {
                this.$message({
                    message: '请输入检查应用名称',
                    type: 'warning'
                });
            } else {
                if (app.frequency == '只能检查一次') {
                    var frequency = '1'
                }
                if (app.frequency == '每天检查一次') {
                    var frequency = '2'
                }
                if (app.frequency == '每天检查多次') {
                    var frequency = '3'
                }
                if (app.is_public_query) {
                    var is_public_query = '2'
                } else {
                    var is_public_query = '1'
                }
                let data = {
                    app_name: app.app_name,
                    frequency: frequency,
                    is_published: app.is_published,
                    is_public_query: is_public_query
                }
                axios({
                        method: 'put',
                        headers: {
                            "Authorization": localStorage.getItem('token')
                        },
                        url: config.base_url + '/yun_table/yun_jiancha/apps/' + this.app_id,
                        data: data
                    })
                    .then(function(response) {
                        //console.log(response)
                        localStorage.setItem(response.data.app_id, JSON.stringify(response.data))
                        _this.$message({
                            message: '检查应用修改成功',
                            type: 'success'
                        });
                    })
                    .catch((err) => {
                        //console.log(err.response)
                        let err_data = err.response.data.err_msg
                        this.$message({
                            message: err_data,
                            type: 'error'
                        })
                    })}
            },
            handleDelete() {
                    let _this = this;
                    this.$confirm('此操作将永久删除该检查应用及其相关数据, 是否继续?', '谨慎操作', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        axios({
                                method: 'delete',
                                headers: {
                                    "Authorization": localStorage.getItem('token')
                                },
                                url: config.base_url + '/yun_table/yun_jiancha/apps/' + _this.app_id
                            }).then(function(response) {
                                console.log(response)

                                _this.$message({
                                    type: 'success',
                                    message: '删除成功!'
                                });
                                localStorage.removeItem(_this.app_id, JSON.stringify(response.data))
                                _this.$router.push({
                                    path: '/yunjiancha'
                                })
                            })
                            .catch((err) => {
                                //console.log(err.response)
                                let err_data = err.response.data.err_msg
                                this.$message({
                                    message: err_data,
                                    type: 'error'
                                })
                            })
                    }).catch(() => {
                        this.$message({
                            type: 'info',
                            message: '已取消删除'
                        });
                    });
                },

        }
    }
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
</style>